<template>
  <b-tab title="General" :active="active">
    <b-form @submit="saveSettings">
      <b-card title="Restrictions">
        <b-alert show
          >Use this section to restrict landing users to visit the page, for
          example if you trade products with age restriction or users may accept
          certain conditions</b-alert
        >
        <b-row>
          <b-col>
            <b-form-group
              label="Landing Title"
              description="Enter the title for the restriction message"
            >
              <b-form-input
                required
                v-model="landingRestriction.title"
                placeholder="Are you 18+ or approved to visit this site?"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label="Landing Question"
              description="Question or information that user may need to approve before proceeding to purchase your products"
            >
              <b-form-textarea
                required
                v-model="landingRestriction.question"
                placeholder="i.e: In order to allow access to our site you must comply with certain regulations, etc."
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              label="Accept button text"
              description="Specify a custom text to be displayed on the acceptance button"
            >
              <b-form-input
                placeholder="i.e: Yes, I'm 18+"
                v-model="landingRestriction.okText"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label="Cancel button text"
              description="Specify a custom text to be displayed on the rejection button"
            >
              <b-form-input
                placeholder="i.e: No, I'm not 18+"
                v-model="landingRestriction.cancelText"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group
          label="Rejection text"
          description="Set here the text to display when a user doesn't agree with your landing question"
        >
          <b-form-textarea
            required
            placeholder="You don't met the criteria to purchase products on this site"
            v-model="landingRestriction.cancellationDescription"
          />
        </b-form-group>
        <b-row>
          <b-col>
            <b-form-group
              label="Exit button text"
              description="Specify a custom text to be displayed on the exit button after user terms rejection"
            >
              <b-form-input
                placeholder="i.e: Ok, Take me out of this site"
                v-model="landingRestriction.cancellationText"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label="Confirm on every visit"
              description="Whenever user will see this confirmation popup on every single site visit"
            >
              <b-form-select v-model="landingRestriction.confirmOnAllVisits">
                <b-form-select-option :value="true">Yes</b-form-select-option>
                <b-form-select-option :value="false">No</b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <template #footer>
          <b-button
            class="float-right mt-3 ml-2"
            variant="primary"
            pill
            type="submit"
          >
            Save
          </b-button>
          <b-button
            :variant="
              landingRestriction.enabled ? 'outline-danger' : 'outline-primary'
            "
            @click="toggleRestriction"
            class="float-right mt-3"
            :disabled="loading"
            pill
          >
            <b-spinner v-if="loading" />
            <span v-else
              >{{ landingRestriction.enabled ? "Disable" : "Enable" }} Landing
              Restriction</span
            >
          </b-button>
        </template>
      </b-card>
    </b-form>
    <b-form @submit="saveGeneralSettings" class="pt-5">
      <b-card title="General">
        <b-row>
          <b-col>
            <b-form-group
              description="Whenever you which to display $0 on products with 0 cost or hide the price tag"
            >
              <b-form-checkbox
                required
                v-model="generalSettings.hideZeroCostPricing"
              >
                Hide Zero Cost Price?
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <template #footer>
          <b-button
            class="float-right mt-3 ml-2"
            variant="primary"
            pill
            type="submit"
          >
            Save
          </b-button>
        </template>
      </b-card>
    </b-form>
  </b-tab>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Settings",
  props: ["embedKey", "active"],
  data: () => ({
    loading: false,
    landingRestriction: {
      enabled: false,
      title: "",
      question: "",
      okText: "",
      cancelText: "",
      cancellationDescription: "",
      cancellationText: "",
    },
    generalSettings: {
      hideZeroCostPricing: false,
    },
  }),
  computed: {
    ...mapGetters("shop", ["shop"]),
  },
  methods: {
    saveSettings(event) {
      event.preventDefault();
      this.$store.dispatch("shop/UPDATE_EMBED_KEY", {
        shopId: this.shop._id,
        embedKeyInfo: {
          landingRestriction: this.landingRestriction,
        },
      });
    },
    saveGeneralSettings(event) {
      event.preventDefault();
      this.$store.dispatch("shop/UPDATE_EMBED_KEY", {
        shopId: this.shop._id,
        embedKeyInfo: {
          general: this.generalSettings,
        },
      });
    },
    toggleRestriction(e) {
      this.landingRestriction.enabled = !this.landingRestriction.enabled;
      this.saveSettings(e);
    },
  },
  mounted() {
    if (this.embedKey) {
      this.landingRestriction = this.embedKey.landingRestriction;
      this.generalSettings = this.embedKey.general;
    }
  },
  watch: {
    embedKey(newVal) {
      if (newVal) {
        this.landingRestriction = newVal.landingRestriction;
        this.generalSettings = newVal.general;
      }
    },
  },
};
</script>

<style scoped></style>
